import { render, staticRenderFns } from "./JTime.vue?vue&type=template&id=90883714&scoped=true&"
import script from "./JTime.vue?vue&type=script&lang=js&"
export * from "./JTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90883714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90883714')) {
      api.createRecord('90883714', component.options)
    } else {
      api.reload('90883714', component.options)
    }
    module.hot.accept("./JTime.vue?vue&type=template&id=90883714&scoped=true&", function () {
      api.rerender('90883714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JTime.vue"
export default component.exports